import { getAppContext } from "@viagogo/core/utils";
import { captureException } from "@viagogo/cx-sentry";
import type { AppContext } from "src/shared/context/AppContext";
import { getOwnerFromComponent } from "./getOwnerFromComponent";
import { initSentry } from "./sentry";
import { SentryTags } from "./SentryTags";

const captureExceptionWithOwner = (error: Error) => {
  captureException(error, {
    tags: {
      [SentryTags.TEAM_OWNER]: getOwnerFromComponent(),
    },
  });
};

const initErrorSentry = (err?: unknown) => {
  // Provide a minimal env so initSentry doesn't throw on env access.
  // All env values are missing, so Sentry initializes with enabled:false (safe degraded state).
  initSentry({ env: {} } as AppContext);
  const error = new Error("Error initializing Sentry with AppContext");
  if (err instanceof Error) {
    err.cause = error;
    captureExceptionWithOwner(err);
  } else if (typeof err === "string") {
    const errorInst = new Error(err);
    errorInst.cause = error;
    captureExceptionWithOwner(errorInst);
  } else {
    captureExceptionWithOwner(error);
  }
};

// Guard during SSR: sentry-init is a standalone Vite entrypoint loaded before the React tree,
// where window and __APP_CONTEXT__ are unavailable.
if (typeof window !== "undefined") {
  try {
    const appContext = getAppContext<AppContext>()!;
    initSentry(appContext);
  } catch (error) {
    initErrorSentry(error);
  }
}
